import gql from "graphql-tag";

export const DELETE_COMMENT = gql`
  subscription {
    deleteComment {
      _id
      content
      created_at
      edited
      created_by {
        _id
        full_name
        email
        avatar
      }
    }
  }
`;
